(function () {
  angular
    .module("akitabox.core.services.maintenanceType", [
      "akitabox.constants",
      "akitabox.core.services.http",
      "angular-cache",
    ])
    .factory("MaintenanceTypeService", MaintenanceTypeService);

  /** @ngInject */
  function MaintenanceTypeService(
    // Constants
    models,
    // Services
    HttpService
    // Third-party
    // CacheFactory
  ) {
    var cache;

    init();

    function init() {
      // TODO: Re-add once types are moved to organization-level
      // cache = CacheFactory.get("maintenanceTypes");
      // if (!cache) {
      //   cache = CacheFactory("maintenanceTypes");
      // }
    }

    var service = {
      // Routes
      buildBaseRoute: buildBaseRoute,
      buildDetailRoute: buildDetailRoute,
      buildListRoute: buildListRoute,
      // Retrieve
      get: get,
      getById: getById,
      getAll: getAll,
    };

    return service;

    // ------------------------
    //   Public Functions
    // ------------------------

    /******************* *
     *   Routes
     * ****************** */

    function buildBaseRoute(buildingId) {
      return (
        "/" +
        models.BUILDING.ROUTE_PLURAL +
        "/" +
        buildingId +
        "/" +
        models.MAINTENANCE_TYPE.ROUTE_PLURAL
      );
    }

    function buildDetailRoute(buildingId, maintenanceTypeId) {
      var base = buildBaseRoute(buildingId);
      return base + "/" + maintenanceTypeId;
    }

    function buildListRoute(buildingId) {
      return buildBaseRoute(buildingId);
    }

    /******************* *
     *   Retrieve
     * ****************** */

    function get(buildingId, params, options) {
      var route = buildListRoute(buildingId);
      // TODO: Re-add once types are moved to organization-level
      // if (options && !options.cache) {
      //   return HttpService.get(route, params);
      // }
      return HttpService.get(route, params, cache);
    }

    function getAll(buildingId, params, options) {
      var route = buildListRoute(buildingId);
      // TODO: Re-add once types are moved to organization-level
      // if (options && !options.cache) {
      //   return HttpService.getAll(route, params);
      // }
      return HttpService.getAll(route, params, cache);
    }

    function getById(buildingId, maintenanceTypeId, params, options) {
      var route = buildDetailRoute(buildingId, maintenanceTypeId);
      // TODO: Re-add once types are moved to organization-level
      // if (options && !options.cache) {
      //   return HttpService.getById(route, maintenanceTypeId, params);
      // }
      return HttpService.getById(route, maintenanceTypeId, params, cache);
    }
  }
})();
